import elliptic from 'elliptic'
import lodash from 'lodash'

const { once } = lodash

export const getEd25519 = once(() => elliptic.eddsa('ed25519'))
